import React, { useState, useEffect, useRef, useContext } from 'react';
import { ImCancelCircle } from 'react-icons/im';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import TransactionForm from './TransactionForm';
import TransactionApi from '../api/TransactionApi';
import Pagination from '../component/paginations/pagination';
import SettingApi from '../api/SettingApi';
import ContactApi from '../api/ContactApi';
import { SettingsContext } from '../Context/SettingContext';


const TransactionList = ({ refresh, invoiceData, invoices }) => {
  const [state, setState] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [fetchData, setFetchingData] = useState(false);
  const taskDetailsRef = useRef(null);
  const [editTransactionId, setEditTransactionId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const {settings} = useContext(SettingsContext);
  const [contacts, setContacts] = useState([]);
  const validLocale = ['en-US', 'bn-BD'].includes(settings?.region) ? settings.region : 'en-US';
  useEffect(() => {
    if (invoices !== 'true') {
      getTransaction();
    }
  }, [refresh]);

  useEffect(() => {
    if (invoiceData) {
      getTransactions(invoiceData.id);
    }
  }, [invoiceData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (taskDetailsRef.current && !taskDetailsRef.current.contains(event.target)) {
        setShowDetails(false);
      }
    };

    if (showDetails) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDetails]);

//   const getContact = async () => {
//     const res = await ContactApi.index();
//     if (Array.isArray(res)) {
//         setContacts(res);
//         console.log(res);
//     } else {
//         console.error("API response is not an array:", res);
//     }
// };

  const getTransactions = async (id) => {
    setFetchingData(true);
    try {
      const res = await TransactionApi.invoiceDetails(id);
      if (res) {
        setState(res);
        setFetchingData(false);
      }
    } catch (error) {
      console.error('Error fetching transactions:', error);
      setFetchingData(false);
    }
  };

  // const getSettings = async () => {
  //   const res = await SettingApi.index();
  //   setSetting(res.data);
  // };

  const getTransaction = async () => {
    try {
      const res = await TransactionApi.index();
      if (Array.isArray(res)) {
        setState(res);
      } else {
        console.error('API response is not an array:', res);
      }
    } catch (error) {
      console.error('Error fetching transactions:', error);
    }
  };

  const deleteTransaction = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this transaction?');

    if (confirmDelete) {
      try {
        const res = await TransactionApi.delete(id);
        if (res) {
          getTransaction();
        }
      } catch (error) {
        console.error('Error deleting transaction:', error);
      }
    }
  };

  const toggleDetails = (transactionId = null) => {
    setShowDetails(!showDetails);
    setEditTransactionId(transactionId);
  };

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPosts = state.slice(firstPostIndex, lastPostIndex);

  const handlePostsPerPageChange = (e) => {
    const newPostsPerPage = parseInt(e.target.value, 10);
    setPostsPerPage(newPostsPerPage);
    setCurrentPage(1); // Reset to the first page when changing posts per page
  }; 

  // console.log('inv trancitiondata:',invoiceData);
  // console.log('TRANSECTION state:',state);


  

  return (
    <div>
      {!fetchData ? (
        <div className="mx-auto">
          <div className="flex items-center justify-between bg-white px-6 py-4 border-b">
            <div className="text-lg text-gray-500">
              <h1>All Transactions</h1>
            </div>
            {invoices !== 'true' && (
              <div>
                <button
                  onClick={() => toggleDetails()}
                  ref={taskDetailsRef}
                  className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
                >
                  Add
                </button>
              </div>
            )}
          </div>
          <div className="flex flex-col">
            <div className="overflow-x-auto shadow-md sm:rounded-lg">
              <div className="inline-block min-w-full align-middle">
                <div className="overflow-hidden ">
                  <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                    <thead className="bg-gray-100 dark:bg-gray-700">
                      <tr>
                        <th scope="col" className="p-4">
                          <div className="flex items-center">
                            <input
                              id="checkbox-all"
                              type="checkbox"
                              className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            />
                            <label htmlFor="checkbox-all" className="sr-only">
                              checkbox
                            </label>
                          </div>
                        </th>
                        {invoices !== 'true' && (
                          <th
                            scope="col"
                            className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"
                          >
                            Type
                          </th>
                        )}
                        <th
                          scope="col"
                          className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"
                        >
                          Amount
                        </th>
                        <th
                          scope="col"
                          className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"
                        >
                          Paid At
                        </th>
                        {invoices !== 'true' && (
                          <th
                          scope="col"
                          className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"
                        >
                          Customer
                        </th>

                        )}
                        
                        {invoices !== 'true' && (
                          <th scope="col" className="p-4">
                            <span className="sr-only">Edit</span>
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                      {currentPosts.map((transaction, index) => (
                        <tr
                          className="hover:bg-gray-100 dark:hover:bg-gray-700"
                          key={index}
                        >
                          <td className="p-4 w-4">
                            <div className="flex items-center">
                              <input
                                id="checkbox-table-1"
                                type="checkbox"
                                className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                              />
                              <label
                                htmlFor="checkbox-table-1"
                                className="sr-only"
                              >
                                checkbox
                              </label>
                            </div>
                          </td>
                          {invoices !== 'true' && (
                            <td className=" px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                              {transaction.type}
                            </td>
                          )}
                          <td className=" px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                            ${transaction.amount}
                          </td>
                          <td className=" px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                            {new Intl.DateTimeFormat(validLocale).format(new Date(transaction?.paid_at))}
                          </td>

                          {invoices !== 'true' && (
                            <td className="px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                            {transaction.contact_name}
                          </td>
                          )}
                          
                          
                          {invoices !== 'true' && (
                            <td className=" p-3 text-sm font-medium float-right whitespace-nowrap flex my-auto">
                              <a
                                onClick={() => toggleDetails(transaction.id)}
                                ref={taskDetailsRef}
                                href="#"
                                title='Edit'
                                className="text-blue-600 dark:text-blue-500 hover:underline text-2xl"
                              >
                                <FaEdit />
                              </a>
                              <button
                                onClick={() => deleteTransaction(transaction.id)}
                                href="#"
                                title='Delete'
                                className="ml-2 text-blue-600 dark:text-blue-500 hover:underline text-2xl"
                              >
                                <MdDelete />
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {(state.length > 0 && invoices !== 'true')&&(
              <div className="flex justify-end items-center mt-4 gap-4">
                <div className="flex items-center border border-gray-300 rounded-lg px-4 py-1 bg-white shadow-sm">
                  <p className="mr-2 text-gray-700">Per Page</p>
                  <select
                    className="appearance-none pl-2 pr-5 py-1 text-gray-700 focus:outline-none focus:border-indigo-500"
                    value={postsPerPage}
                    onChange={handlePostsPerPageChange}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                  </select>
                </div>

                <Pagination
                  totalPosts={state.length}
                  postsPerPage={postsPerPage}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                />
              </div>
            )}
          </div>
          {showDetails && (
            <div
              className="fixed z-10 top-8 md:top-8 right-0 w-full h-full shadow-2xl max-w-[50rem] bg-white transition-transform duration-300 overflow-y-auto transform translate-x-0"
              ref={taskDetailsRef}
            >
              <div className="flex justify-between p-3">
                <a
                  className="mt-2 !ml-2 text-2xl text-gray-400 cursor-pointer"
                  onClick={toggleDetails}
                >
                  <ImCancelCircle />
                </a>
              </div>
              <div>
                <TransactionForm
                  transactionId={editTransactionId}
                  onSubmits={getTransaction}
                  toggle={toggleDetails}
                  currentPosts={currentPosts}

                  // settings={settings}
                />
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="m-auto">
          <p className="text-2xl font-bold text-center">Loading...</p>
        </div>
      )}
    </div>
  );
};

export default TransactionList;
